module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindents"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v("“Tobacco manufacturers are exposed to a strong narcotic odor . . . men breathe an atmosphere strongly impregnated with a poisonous substance, yet become insensible to its influence.”")]), _vm._v(" "), _c('p', {
    staticClass: "rightr"
  }, [_vm._v("C. Turner Thackrah, “Effects of Arts, Trades,"), _c('br'), _vm._v("\n  and Professions on Health and Longevity,” 1832")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16b80b41","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/frontmatter03.vue
// module id = 81
// module chunks = 0